export const DEFAULT_TAB = 'default';

export const DEFAULT_MANDELBROT_CANVAS_SIZE = 600;
